<template>
  <subscribe/>
</template>

<script>
import Subscribe from '../_Shared/Subscribe'

export default {
  name: 'channel-sign-up',
  components: {
    'subscribe': Subscribe
  },
  props: {
  },
  mixins: [],
  data () {
    return {
    }
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  .pricing-container {
    max-width: $maxWidth;
    margin: auto;
  }

</style>
